import { Record } from 'immutable';

export interface DeviceManagementInterface {
  devices: Object;
}

export const initialState: DeviceManagementInterface = {
  devices: {}
};

export default class DeviceManagementState extends Record(initialState) { }
